import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useHreflang } from "../../i18n/hooks/useHreflang";
import { getLocaleFromPath } from "../../i18n/config";
import { metadataTranslations } from "../../i18n/metadata";
import styles from "./memoryGame.module.css";

const MemoryGame = () => {
    const hreflang = useHreflang("muistipeli");
    const locale = getLocaleFromPath();
    const meta = metadataTranslations.memory_game[locale] || metadataTranslations.memory_game.fi;
    return (
        <Container fluid className={styles["memory-game-container"]}>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <link rel="alternate" hrefLang="fi" href={hreflang.fi} />
                <link rel="alternate" hrefLang="en" href={hreflang.en} />
                <link rel="alternate" hrefLang="sv" href={hreflang.sv} />
                <link rel="alternate" hrefLang="x-default" href={hreflang.fi} />
            </Helmet>
            {/* Header Section */}
            <section className={styles["header-section"]}>
                <img src="/assets/images/memoryGame/app_icon.png" alt="Muistipeli" className={styles["app-icon"]} />
                <div className={styles["header-text"]}>
                    <h1 className={styles["main-title"]}>Muistipeli Appi</h1>
                    <p className={styles["subtitle"]}>Pelaa hauskinta muistipeliä! Senioreille, aikuisille ja lapsille. Happy Memory Game.</p>
                </div>
            </section>

            {/* App Store Badges Section */}
            <section className={styles["app-store-badges"]}>
                <a href="https://apps.apple.com/us/app/happy-memory-game/id6748531043" target="_blank" rel="noopener noreferrer">
                    {" "}
                    <img src="/assets/icons/download_on_app_store_finnish.svg" alt="apple app store" className={styles["badge-img"]} />
                </a>
                <a href="https://play.google.com/store/apps/details?id=fi.digihappy.muistipeli" target="_blank" rel="noopener noreferrer">
                    {" "}
                    <img src="/assets/icons/GetItOnGooglePlay_Badge_Web_color_Finnish.png" alt="google app store" className={styles["badge-img"]} />
                </a>
            </section>

            {/* Main Content Section */}
            <Row className={styles["main-content-card"]}>
                <Col xs={12} lg={2} className={styles["features-left"]}>
                    <p>Ei mainoksia</p>
                    <p>Puhelimelle ja tabletille</p>
                    <p>Maksuton</p>
                </Col>
                <Col xs={12} lg={4} className={styles["phone-mockup-col"]}>
                    <img src="/assets/images/memoryGame/memorygame1.png" alt="Muistipeli" className={styles["phone-img"]} />
                </Col>
                <Col xs={12} lg={4} className={styles["phone-mockup-col"]}>
                    <img src="/assets/images/memoryGame/memorygame2.png" alt="Muistipeli" className={styles["phone-img"]} />
                </Col>
                <Col xs={12} lg={2} className={styles["features-right"]}>
                    <p>Vaihtuvat kuvat</p>
                    <p>Hauskaa ilman sanoja</p>
                    <p>Voita kello</p>
                </Col>
            </Row>
        </Container>
    );
};

export default MemoryGame;
